var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavesbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_21_1",
    "data-name": "Component 21 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 558,
    height: 503.975,
    viewBox: "0 0 558 503.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(152 -16)",
    opacity: 0.059
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-152 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M350.949,1121.912s-27.783-63.631,30.1-97.865c40.909-26.081,116.987-47.075,147.052-70.332,38.476,83.617-39.7,115.713-113.281,140.619C353.72,1117.127,350.949,1121.912,350.949,1121.912Z",
    transform: "translate(-167.355 -785.51)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M331.093,1140.727s-27.783-63.631,30.1-97.874c40.909-26.082,116.988-47.076,147.052-70.332,38.476,83.626-39.7,115.713-113.29,140.627C333.864,1135.942,331.093,1140.727,331.093,1140.727Z",
    transform: "translate(-324.428 -636.752)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M370.813,1103.044s-27.783-63.63,30.1-97.874C441.821,979.089,517.9,958.1,547.956,934.839c38.476,83.626-39.7,115.714-113.281,140.627C373.584,1098.26,370.813,1103.044,370.813,1103.044Z",
    transform: "translate(-10.219 -934.839)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(255.542 134.167)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M374.742,1086.977s-22.642-51.86,24.531-79.759c33.335-21.252,95.334-38.361,119.839-57.322,31.356,68.148-32.355,94.3-92.323,114.607C377.005,1083.073,374.742,1086.977,374.742,1086.977Z",
    transform: "translate(-224.923 -949.896)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M358.538,1103.647s-22.642-51.85,24.531-79.759c33.334-21.252,95.335-38.36,119.83-57.313,31.357,68.148-32.345,94.3-92.314,114.6C360.792,1099.753,358.538,1103.647,358.538,1103.647Z",
    transform: "translate(-353.106 -817.947)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0.004 59.853)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M346.064,1078.635s-22.642-51.859,24.531-79.758c33.335-21.252,95.335-38.361,119.839-57.322,31.357,68.147-32.355,94.3-92.323,114.607C348.327,1074.733,346.064,1078.635,346.064,1078.635Z",
    transform: "translate(-196.245 -941.556)",
    fill: "#50a634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M329.86,1095.307s-22.642-51.851,24.531-79.75c33.335-21.261,95.334-38.36,119.83-57.322,31.356,68.148-32.346,94.3-92.314,114.6C332.114,1091.414,329.86,1095.307,329.86,1095.307Z",
    transform: "translate(-324.428 -809.607)",
    fill: "#50a634"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M377.43,1041.4s-12.92-29.6,14.008-45.525c19.024-12.135,54.417-21.9,68.4-32.719,17.9,38.894-18.463,53.828-52.7,65.412C378.723,1039.169,377.43,1041.4,377.43,1041.4Z",
    transform: "translate(70.345 -710.85)",
    fill: "#50a634",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M330.326,1030.286s-12.929-29.6,14-45.523c19.033-12.136,54.417-21.894,68.4-32.72,17.9,38.9-18.463,53.828-52.688,65.412C331.618,1028.058,330.326,1030.286,330.326,1030.286Z",
    transform: "translate(-302.32 -798.745)",
    fill: "#50a634",
    opacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesbg);
export default __webpack_public_path__ + "static/media/wavesbg.f144a9fdc5aa73397efedfa384065a0c.svg";
export { ForwardRef as ReactComponent };